module.exports = __webpack_public_path__ + "static/img/20003 (2).fd8d34b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (2).webp
// module id = +aDY
// module chunks = 14